// extracted by mini-css-extract-plugin
export default {"badgeIcons":"VerificationBadges_badgeIcons__KHWc0","chatPageUnverified":"VerificationBadges_chatPageUnverified__bP34A","badgesWrapper":"VerificationBadges_badgesWrapper__ACUgu"};